var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSuggestions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.941,
    height: 26.298,
    viewBox: "0 0 27.941 26.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "online-course",
    transform: "translate(0 -15.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52878",
    "data-name": "Path 52878",
    d: "M22.53,82.765h26.3v18.5H22.53Z",
    transform: "translate(-21.3 -64.014)",
    fill: "#ecf4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52879",
    "data-name": "Path 52879",
    d: "M255.94,82.765H269.5v18.5H255.94Z",
    transform: "translate(-241.969 -64.014)",
    fill: "#d5e7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52880",
    "data-name": "Path 52880",
    d: "M162.037,407.414V410.7c0,.453-.856.405-1.384.405l-9.1-.009c-.528,0-1.023.057-1.023-.4v-3.288a.9.9,0,0,1,.956-.819h9.6A.9.9,0,0,1,162.037,407.414Z",
    transform: "translate(-142.312 -370.167)",
    fill: "#3f558f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52881",
    "data-name": "Path 52881",
    d: "M261.694,407.414V410.7c0,.453-.443.5-.972.5l-4.782.093v-4.7h4.8A.9.9,0,0,1,261.694,407.414Z",
    transform: "translate(-241.969 -370.167)",
    fill: "#1c3470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52882",
    "data-name": "Path 52882",
    d: "M108.428,467.644a.819.819,0,0,1-.819.819H91.169a.819.819,0,0,1,0-1.638h8.22l6.335.564C106.176,467.389,108.428,467.192,108.428,467.644Z",
    transform: "translate(-85.418 -427.11)",
    fill: "#5a729e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52883",
    "data-name": "Path 52883",
    d: "M264.979,467.644a.819.819,0,0,1-.819.819h-8.22v-1.638h8.22A.819.819,0,0,1,264.979,467.644Z",
    transform: "translate(-241.969 -427.11)",
    fill: "#3f558f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52884",
    "data-name": "Path 52884",
    d: "M27.941,68.584v18.5a.819.819,0,0,1-.819.819H.819A.819.819,0,0,1,0,87.079v-18.5a.819.819,0,0,1,.819-.819H5.751a.819.819,0,1,1,0,1.638H1.638V86.26H26.3V69.4H22.6a.819.819,0,1,1,0-1.638h4.521A.819.819,0,0,1,27.941,68.584Z",
    transform: "translate(0 -49.833)",
    fill: "#5a729e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52885",
    "data-name": "Path 52885",
    d: "M269.911,68.584v18.5a.819.819,0,0,1-.819.819H255.94V86.26h12.333V69.4h-3.7a.819.819,0,1,1,0-1.638h4.521A.819.819,0,0,1,269.911,68.584Z",
    transform: "translate(-241.969 -49.833)",
    fill: "#3f558f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52886",
    "data-name": "Path 52886",
    d: "M155.383,87.123v3.836a.818.818,0,0,1-.525.764l-5.637,2.11c-.218,0-.135,0-5.637-2.11a.819.819,0,0,1-.525-.764V87.034a.819.819,0,0,1,1.638,0c0,.012-.4,0,9.049.082a.819.819,0,0,1,1.637.007Z",
    transform: "translate(-135.251 -67.276)",
    fill: "#5a729e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52887",
    "data-name": "Path 52887",
    d: "M262.1,88.664V92.5a.818.818,0,0,1-.525.764c-5.482,2.111-5.421,2.11-5.637,2.11V88.62l4.525.038a.819.819,0,0,1,1.637.007Z",
    transform: "translate(-241.969 -68.817)",
    fill: "#3f558f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52888",
    "data-name": "Path 52888",
    d: "M108.863,18.751V24.5a.819.819,0,1,1-1.638,0l.344-5.224-8.157,3.166c-.2,0-.117,0-8.49-2.923a.82.82,0,0,1,0-1.546c8.363-2.926,8.29-2.923,8.49-2.923l8,3.251C107.747,18.417,108.863,18.4,108.863,18.751Z",
    transform: "translate(-85.443 0)",
    fill: "#3f558f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52889",
    "data-name": "Path 52889",
    d: "M265.39,18.751V24.5a.819.819,0,1,1-1.638,0V19.887c-7.644,2.563-7.62,2.56-7.812,2.56V15.055c.19,0,.1,0,8.89,2.919A.818.818,0,0,1,265.39,18.751Z",
    transform: "translate(-241.969 0)",
    fill: "#1c3470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52890",
    "data-name": "Path 52890",
    d: "M64.341,271.062H61.053a.819.819,0,0,0-.819.819v3.288a.819.819,0,0,0,.819.819h3.288a.819.819,0,0,0,.819-.819v-3.288A.819.819,0,0,0,64.341,271.062Z",
    transform: "translate(-56.946 -242.033)",
    fill: "#fc6284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52891",
    "data-name": "Path 52891",
    d: "M195.49,271.884a.819.819,0,0,1-.819.819H181.519a.819.819,0,0,1,0-1.638h13.152A.819.819,0,0,1,195.49,271.884Z",
    transform: "translate(-170.836 -242.035)",
    fill: "#01c1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52892",
    "data-name": "Path 52892",
    d: "M195.49,332.114a.819.819,0,0,1-.819.819H181.519a.819.819,0,0,1,0-1.638h13.152A.819.819,0,0,1,195.49,332.114Z",
    transform: "translate(-170.836 -298.978)",
    fill: "#01c1f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45576",
    "data-name": "Group 45576",
    transform: "translate(13.971 29.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52893",
    "data-name": "Path 52893",
    d: "M266.623,332.114a.819.819,0,0,1-.819.819H255.94v-1.638H265.8A.819.819,0,0,1,266.623,332.114Z",
    transform: "translate(-255.94 -328.007)",
    fill: "#00ade9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52894",
    "data-name": "Path 52894",
    d: "M265.8,272.7H255.94v-1.638H265.8a.819.819,0,0,1,0,1.638Z",
    transform: "translate(-255.94 -271.065)",
    fill: "#00ade9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSuggestions);
export default __webpack_public_path__ + "static/media/home-suggestions.1628b296ea3b291628cbe3f5d9038b61.svg";
export { ForwardRef as ReactComponent };